// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-color: #00f2fe;
  --secondary-color: #4facfe;
  --accent-color: #fa709a;
  --dark-bg: #0a0a0a;
  --dark-secondary: #1a1a1a;
  --text-primary: #ffffff;
  --text-secondary: #b0b0b0;
  --gradient-primary: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  --gradient-accent: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  --shadow-glow: 0 0 40px rgba(0, 242, 254, 0.5);
  --transition-smooth: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

body {
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--dark-bg);
  color: var(--text-primary);
  overflow-x: hidden;
  line-height: 1.6;
}

.App {
  min-height: 100vh;
  position: relative;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: var(--dark-secondary);
}

::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 5px;
  -webkit-transition: var(--transition-smooth);
  transition: var(--transition-smooth);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--secondary-color);
}

/* Section Spacing */
section {
  padding: 80px 0;
  position: relative;
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Headings */
h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
}

h1 {
  font-size: clamp(2.5rem, 5vw, 4rem);
}

h2 {
  font-size: clamp(2rem, 4vw, 3rem);
}

h3 {
  font-size: clamp(1.5rem, 3vw, 2rem);
}

/* Text Gradient Effect */
.gradient-text {
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Glow Effect */
.glow {
  filter: drop-shadow(0 0 20px rgba(0, 242, 254, 0.5));
}

/* Button Styles */
.btn {
  display: inline-block;
  padding: 12px 30px;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  border-radius: 50px;
  transition: var(--transition-smooth);
  cursor: pointer;
  border: none;
  outline: none;
  position: relative;
  overflow: hidden;
}

.btn-primary {
  background: var(--gradient-primary);
  color: var(--dark-bg);
  box-shadow: 0 4px 15px rgba(0, 242, 254, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(0, 242, 254, 0.5);
}

.btn-secondary {
  background: transparent;
  color: var(--text-primary);
  border: 2px solid var(--primary-color);
}

.btn-secondary:hover {
  background: var(--primary-color);
  color: var(--dark-bg);
  box-shadow: 0 4px 15px rgba(0, 242, 254, 0.3);
}

/* Card Styles */
.card {
  background: rgba(26, 26, 26, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 30px;
  transition: var(--transition-smooth);
}

.card:hover {
  transform: translateY(-5px);
  border-color: var(--primary-color);
  box-shadow: 0 10px 30px rgba(0, 242, 254, 0.2);
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

@keyframes gradient-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.fade-in {
  animation: fadeIn 0.8s ease-out forwards;
}

.pulse {
  animation: pulse 2s ease-in-out infinite;
}

.float {
  animation: float 3s ease-in-out infinite;
}

/* Responsive Design */
@media (max-width: 768px) {
  section {
    padding: 60px 0;
  }
  
  .container {
    padding: 0 15px;
  }
  
  h1 {
    font-size: 2rem;
  }
  
  h2 {
    font-size: 1.75rem;
  }
  
  h3 {
    font-size: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAGhB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,qEAAqE;EACrE,oEAAoE;EACpE,8CAA8C;EAC9C,0DAA0D;AAC5D;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,4CAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,oDAAoD;AACtD;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,gBAAgB;AAChB;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* src/App.css */\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --primary-color: #00f2fe;\n  --secondary-color: #4facfe;\n  --accent-color: #fa709a;\n  --dark-bg: #0a0a0a;\n  --dark-secondary: #1a1a1a;\n  --text-primary: #ffffff;\n  --text-secondary: #b0b0b0;\n  --gradient-primary: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);\n  --gradient-accent: linear-gradient(135deg, #fa709a 0%, #fee140 100%);\n  --shadow-glow: 0 0 40px rgba(0, 242, 254, 0.5);\n  --transition-smooth: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nbody {\n  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--dark-bg);\n  color: var(--text-primary);\n  overflow-x: hidden;\n  line-height: 1.6;\n}\n\n.App {\n  min-height: 100vh;\n  position: relative;\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--dark-secondary);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--primary-color);\n  border-radius: 5px;\n  transition: var(--transition-smooth);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--secondary-color);\n}\n\n/* Section Spacing */\nsection {\n  padding: 80px 0;\n  position: relative;\n  z-index: 1;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Headings */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 1rem;\n}\n\nh1 {\n  font-size: clamp(2.5rem, 5vw, 4rem);\n}\n\nh2 {\n  font-size: clamp(2rem, 4vw, 3rem);\n}\n\nh3 {\n  font-size: clamp(1.5rem, 3vw, 2rem);\n}\n\n/* Text Gradient Effect */\n.gradient-text {\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Glow Effect */\n.glow {\n  filter: drop-shadow(0 0 20px rgba(0, 242, 254, 0.5));\n}\n\n/* Button Styles */\n.btn {\n  display: inline-block;\n  padding: 12px 30px;\n  font-size: 1rem;\n  font-weight: 500;\n  text-decoration: none;\n  border-radius: 50px;\n  transition: var(--transition-smooth);\n  cursor: pointer;\n  border: none;\n  outline: none;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-primary {\n  background: var(--gradient-primary);\n  color: var(--dark-bg);\n  box-shadow: 0 4px 15px rgba(0, 242, 254, 0.3);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 25px rgba(0, 242, 254, 0.5);\n}\n\n.btn-secondary {\n  background: transparent;\n  color: var(--text-primary);\n  border: 2px solid var(--primary-color);\n}\n\n.btn-secondary:hover {\n  background: var(--primary-color);\n  color: var(--dark-bg);\n  box-shadow: 0 4px 15px rgba(0, 242, 254, 0.3);\n}\n\n/* Card Styles */\n.card {\n  background: rgba(26, 26, 26, 0.8);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 30px;\n  transition: var(--transition-smooth);\n}\n\n.card:hover {\n  transform: translateY(-5px);\n  border-color: var(--primary-color);\n  box-shadow: 0 10px 30px rgba(0, 242, 254, 0.2);\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-20px);\n  }\n}\n\n@keyframes gradient-shift {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.fade-in {\n  animation: fadeIn 0.8s ease-out forwards;\n}\n\n.pulse {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n.float {\n  animation: float 3s ease-in-out infinite;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  section {\n    padding: 60px 0;\n  }\n  \n  .container {\n    padding: 0 15px;\n  }\n  \n  h1 {\n    font-size: 2rem;\n  }\n  \n  h2 {\n    font-size: 1.75rem;\n  }\n  \n  h3 {\n    font-size: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
